export default __webpack_public_path__ + "static/media/_indianic-white-logo.e0beaefe.svg";